import Feeds from "./Feeds";
import ImageSlide from "./ImageSlide";

const image_list = [
        "/images/bms_1.jpg",
        "/images/bms_2.jpg",
        "/images/bms_3.jpg",
        "/images/bms_4.jpg",
        "/images/bms_5.jpg",
        "/images/bms_6.jpg",
        "/images/bms_7.jpg",
        "/images/bms_8.jpg",
        "/images/bms_9.jpg",
        "/images/bms_10.jpg",
        "/images/bms_11.jpg",
        "/images/bms_12.jpg",
        "/images/bms_13.jpg", 
        
];

function Home() {
    return (
      <div>
        <ImageSlide images={image_list} />
        <Feeds />
      </div>
    );
  }
  
  export default Home;
  